import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../../services/services.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  count =0;
  user_name ='';
  currentLanguage: string = 'en';

  constructor(private _services: ServicesService, private router: Router, public translate: TranslateService) {
    this.currentLanguage = this.translate.currentLang ? this.translate.currentLang : 'en';
    //console.log("aa", this.currentLanguage)
  }

  ngOnInit() {
  }

  logout() {
      swal({
        title: 'Are you sure?',
        text: 'You want to logout!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(17, 205, 239)',
        cancelButtonColor: 'rgb(245, 54, 92)',
        confirmButtonText: 'Yes'
      }).then((result) => {
      if (result.value) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['/']);
      }
      })
  }

  changeLanguage() {
    //console.log("cccc", this.currentLanguage)
    this.translate.use(this.currentLanguage);
  }
}
